// extracted by mini-css-extract-plugin
module.exports = {"container":"FullWidthImage-module--container--y_ldq","smallContainer":"FullWidthImage-module--smallContainer--1C0ul"};